// extracted by mini-css-extract-plugin
export default {"syncRotate":"StatusIcon_syncRotate__Og0C9","syncRotation":"StatusIcon_syncRotation__0HwI8"};